import { render, staticRenderFns } from "./ProductAssociation.vue?vue&type=template&id=681cf0ac&"
import script from "./ProductAssociation.vue?vue&type=script&lang=js&"
export * from "./ProductAssociation.vue?vue&type=script&lang=js&"
import style0 from "./ProductAssociation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports